import { useEffect, useState, useSyncExternalStore } from 'react';
import { subscribeRequestLoading, getPendingRequestCount } from '../services/requestLoading';
import './GlobalRequestLoader.css';

const GlobalRequestLoader = () => {
  const pending = useSyncExternalStore(subscribeRequestLoading, getPendingRequestCount, getPendingRequestCount) > 0;
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!pending) { setVisible(false); return undefined; }
    const timer = setTimeout(() => setVisible(true), 200);
    return () => clearTimeout(timer);
  }, [pending]);
  return pending && visible ? <div className="request-loading-indicator" role="status" aria-label="Loading" aria-live="polite">
    <span className="visually-hidden">Loading...</span>
  </div> : null;
};
export default GlobalRequestLoader;
